<template>
  <v-dialog
    v-model="agregarDocumentoDialog"
    width="50%"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        rounded
        small
        color="secondary"
        class="d-inline ml-4"
        v-bind="attrs"
        v-on="on"
        @click="agregarDocumentoDialog = true"
      >
        Agregar documento
      </v-btn>
    </template>
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Nuevo documento
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="agregarDocumentoDialog = false"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="documentoForm"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  v-model="file"
                  label="Documento .jpg"
                  rounded
                  filled
                  background-color="primary"
                  color="secondary"
                  dense
                  :rules="nameRules"
                />
              </v-col>
              <v-col
                v-if="!antecedentes && !validacion"
                cols="12"
              >
                <v-autocomplete
                  v-model="tipoDocumentoElegido"
                  label="Tipo de documento"
                  background-color="primary"
                  color="secondary"
                  rounded
                  filled
                  dense
                  :items="tipoDocumento"
                  item-value="id"
                  item-text="title"
                  :rules="nameRules"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="observaciones"
                  no-resize
                  rows="3"
                  color="secondary"
                  background-color="primary"
                  label="Observaciones (Opcional)"
                  rounded
                  filled
                  dense
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          rounded
          color="secondary"
          :disabled="!documentoForm || loading"
          @click="triggerSaveDocument()"
        >
          Guardar documento
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  props: {
    idPersonal: {
      type: Number,
      default: 0,
    },

    antecedentes: {
      type: Boolean,
      required: false,
    },

    validacion: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      agregarDocumentoDialog: false,

      documentoForm: false,
      loading: false,
      observaciones: '',
      fecha: null,
      nombre: '',
      file: null,
      fileBajoProtesta: null,
      bajoProtesta: false,

      tipoDocumentoElegido: null,

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('tipoDocumento', {
      tipoDocumento: 'getTipoDocumento',
    }),

    getMaxDay() {
      return moment().format('YYYY-MM-DD');
    },
  },

  async mounted() {
    await this.fetchTipoDocumento();
  },

  methods: {
    ...mapActions('tipoDocumento', ['fetchTipoDocumento']),
    ...mapActions('documento', ['saveDocumentoPersonal', 'fetchDocumentoByPersonal']),

    async triggerSaveDocument() {
      this.loading = true;

      if (this.antecedentes) {
        this.tipoDocumentoElegido = 66;
      }

      if (this.validacion) {
        this.tipoDocumentoElegido = 67;
      }

      await this.saveDocumentoPersonal({
        fk_idPersonal: this.idPersonal,
        fk_idTipoDocumento: this.tipoDocumentoElegido,
        observaciones: this.observaciones,
        nombre: this.file.name,
        file: this.file,
      });

      setTimeout(() => {
        this.closeDialog();
      }, 6000);
    },

    async closeDialog() {
      this.loading = false;
      this.observaciones = '';
      this.fecha = null;
      this.nombre = '';
      this.file = null;
      this.fileBajoProtesta = null;
      this.bajoProtesta = false;
      this.agregarDocumentoDialog = false;
      this.tipoDocumentoElegido = null;
      this.$refs.form.resetValidation();
      await this.fetchDocumentoByPersonal(this.idPersonal);
    },
  },
};
</script>
